import { ZodNoCyrillicString } from '@Common/types/zod/zod-no-cyrillic-string';

export const ZodUserFirstName = ZodNoCyrillicString.regex(
  /^([-_'\p{Letter}]+)( [-_'\p{Letter}]+)*$/iu,
)
  .min(2)
  .max(255);

export const ZodUserLastName = ZodNoCyrillicString.regex(/^[ \-_'\p{Letter}]*$/iu)
  .min(2)
  .max(255);
